module.exports = __webpack_public_path__ + "img/IMG_7189_L_WoodMatted_MockedUp.04c85c59.jpg";